import NextLink from 'next/link';
import { ChevronLeft } from 'lucide-react';

import { useTrackEvent } from '@savvy/deprecated-shared/tracking/use-track-event';

import type { ClientPortalCrumb } from './types';
import { CLIENT_PORTAL_MOBILE_BACK_ELEMENT_NAME } from './constants';

type ClientPortalBackLinkProps = {
  readonly crumb: ClientPortalCrumb;
};

export function ClientPortalBackLink({ crumb }: ClientPortalBackLinkProps) {
  const trackInteraction = useTrackEvent('userInteraction');

  return (
    <NextLink
      href={crumb.href ?? ''}
      className="flex min-h-8 items-center gap-1 text-sm text-secondary hover:text-dark"
      onClick={() => {
        trackInteraction({
          elementName: CLIENT_PORTAL_MOBILE_BACK_ELEMENT_NAME,
          htmlElement: 'link',
          interactionType: 'button_click',
        });
      }}
    >
      <ChevronLeft size={16} />
      <span className="truncate">{crumb.label}</span>
    </NextLink>
  );
}
